import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

console.log('Vue 应用开始初始化...')
console.log('Router:', router)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    console.log('Vue 应用已挂载')
    console.log('当前路由:', this.$route)
  }
})



// WEBPACK FOOTER //
// ./src/main.js